import { render, staticRenderFns } from "./SelectResponsibleRetention.vue?vue&type=template&id=4a1fe00e&"
import script from "./SelectResponsibleRetention.vue?vue&type=script&lang=js&"
export * from "./SelectResponsibleRetention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports